import { z } from 'zod';

export const UserResponse = z.object({
  id: z.string(),
  login: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  createdAt: z.coerce.date(),
});

export type TUserResponse = z.infer<typeof UserResponse>;
